module.exports = __webpack_public_path__ + "static/img/ex_img1.8a622d57.png";